import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { FieldType } from '@siclop/ksadmin-vue'

export class ComponentPropertyTypeForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  fieldType: FieldType = FieldType.Text
  category: string = ''
  optionsJson: string = ''
  defaultValue: string = ''
  toolTip: string = ''
  unit: string = ''
  isSystem: boolean = false

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<ComponentPropertyTypeForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.fieldType = enumValue(FieldType, data.fieldType, FieldType.Text)
      this.category = data.category ?? ''
      this.optionsJson = data.optionsJson ?? ''
      this.defaultValue = data.defaultValue ?? ''
      this.toolTip = data.toolTip ?? ''
      this.unit = data.unit ?? ''
      this.isSystem = data.isSystem ?? false
    }
  }
}
